import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { MIN_MOTIVO_MIGRACION } from "@/components/creditos/MigracionCarteraPanel";

export const MIG_LINEA_VACIA = { activo: false, fecha_original: "", motivo: "", numero_anterior: "" };

const hoyMX = () => new Intl.DateTimeFormat("en-CA",
  { timeZone: "America/Mexico_City", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
const hace10 = (h) => `${Number(h.slice(0, 4)) - 10}${h.slice(4)}`;

export const bodyMigracionLinea = (m) => (m.activo ? {
  cartera_migrada: true, fecha_original: m.fecha_original,
  motivo_migracion: m.motivo.trim(), numero_anterior: m.numero_anterior.trim(),
} : {});

export const errorMigracionLinea = (m) => {
  if (!m.activo) return null;
  if (!m.fecha_original) return "Captura la fecha original.";
  if (m.motivo.trim().length < MIN_MOTIVO_MIGRACION)
    return `Escribe el motivo de la migración (mínimo ${MIN_MOTIVO_MIGRACION} caracteres).`;
  return null;
};

// Casilla «migrada de otro sistema» para abrir una línea o disponer de ella (solo admin_entidad).
export function MigracionLineaCampos({ value, onChange, tipo, fechaMin, prefijo }) {
  const hoy = hoyMX();
  const set = (k) => (e) => onChange({ ...value, [k]: e?.target ? e.target.value : e });
  return (
    <div className="rounded-md border border-indigo-300 bg-indigo-50/70 p-3" data-testid={`${prefijo}-migracion`}>
      <label className="flex cursor-pointer items-start gap-2 text-sm font-semibold text-indigo-950">
        <Checkbox checked={value.activo} onCheckedChange={(v) => onChange({ ...value, activo: !!v })}
          data-testid={`${prefijo}-migracion-check`} className="mt-0.5" />
        {tipo === "linea" ? "Línea migrada de otro sistema" : "Disposición migrada de otro sistema"}
      </label>
      {value.activo && (
        <div className="mt-3 space-y-3">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <div>
              <Label className="text-xs">{tipo === "linea" ? "Fecha original de apertura" : "Fecha original de la disposición"} *</Label>
              <Input type="date" value={value.fecha_original} onChange={set("fecha_original")}
                min={fechaMin && fechaMin > hace10(hoy) ? fechaMin : hace10(hoy)} max={hoy}
                data-testid={`${prefijo}-migracion-fecha`} />
            </div>
            <div>
              <Label className="text-xs">{tipo === "linea" ? "No. de línea anterior" : "No. de crédito anterior"}</Label>
              <Input value={value.numero_anterior} onChange={set("numero_anterior")}
                data-testid={`${prefijo}-migracion-numero`} placeholder="Del sistema anterior" />
            </div>
          </div>
          <div>
            <Label className="text-xs">Motivo de la migración *</Label>
            <Textarea rows={2} value={value.motivo} onChange={set("motivo")}
              data-testid={`${prefijo}-migracion-motivo`} placeholder={`Mínimo ${MIN_MOTIVO_MIGRACION} caracteres`} />
          </div>
          <p className="text-[11px] text-indigo-800">
            {tipo === "linea"
              ? "La vigencia de la línea corre desde la fecha original (hasta 10 años atrás)."
              : "La tabla se arma desde la fecha original. En Mesa de Control se desembolsa con esa misma fecha y ahí se capturan las cuotas ya pagadas."}
          </p>
        </div>
      )}
    </div>
  );
}
